import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { getStorefrontByPlatform } from '../../../api/storefront.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { CategoryEntity } from '../../entity/category.entity.js';
import { getProductsObject } from './products.js';
import { memoizeAsync } from '../../../utils/memoize.js';

function fetchCategories(customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const { categories } = yield getStorefrontByPlatform(PLATFORMS.WEB, customStorefrontName);
        const products = yield getProductsObject(customStorefrontName);
        const categoryEntities = categories.map((category) => {
            const categoryEntity = new CategoryEntity(category);
            for (const product of category.products) {
                const productEntity = products ? products[product.productId] : null;
                if (!productEntity) {
                    continue;
                }
                productEntity.updateTileSize(product.sizeInGrid);
                categoryEntity.addProduct(productEntity);
            }
            return categoryEntity;
        });
        return categoryEntities;
    });
}
const getCategories = memoizeAsync(fetchCategories.name, fetchCategories);

export { fetchCategories, getCategories };
//# sourceMappingURL=categories.js.map
